<template>
  <e-column-view-layout :root="rootElement" />
</template>

<script>
import ExportViewer from './ExportViewer';

export default {
  name: 'App',
  components: {},
  beforeCreate() {
    if (window.json.colors.length) {
      window.json.colors.forEach((color) => {
        const style = document.createElement('style');

        // magic number
        // eslint-disable-next-line
        let red = (color.rgb & 0xff).toString(16);

        // magic number
        // eslint-disable-next-line
        let green = ((color.rgb >> 8) & 0xff).toString(16);

        // magic number
        // eslint-disable-next-line
        let blue = ((color.rgb >> 16) & 0xff).toString(16);

        if (red.length === 1) {
          red = `0${red}`;
        }
        if (green.length === 1) {
          green = `0${green}`;
        }
        if (blue.length === 1) {
          blue = `0${blue}`;
        }

        const hex = red + green + blue;

        style.id = `color${color.id}`;
        style.type = 'text/css';
        style.innerHTML = `.color${color.id }, .color${color.id } a span { color:#${hex } !important; }`;
        document.getElementsByTagName('head')[0].appendChild(style);
      });
    }
  },
  data() {
    const itemsAsTree = {};

    let end = false;

    let i = 1;

    let itemWithLongEnoughPath;

    const strings = {};

    // EEV-2: Dummy oberster Knoten, um dort alles einzuhängen
    itemsAsTree.name = 'export';
    itemsAsTree.id = 0;
    itemsAsTree.type = 9999;
    itemsAsTree.isOpen = true;

    const buildChildren = (item) => {
      let parent = null;

      if (item.path && item.path.length === i) {
        itemWithLongEnoughPath = item;

        item.path.forEach((pathPart) => {
          // EEV-6: Nicht direkt die ID als key im Objekt nutzen, sonst wird die Liste unabsichtlich sortiert
          if (parent) {
            parent = parent.childsAsTree['ID_' + pathPart];
          } else {
            parent = itemsAsTree[pathPart] || itemsAsTree;
          }
        });

        if (parent) {
          parent.childsAsTree = parent.childsAsTree || {};
          parent.childsAsTree['ID_' + item.id] = item;
          parent.hasChildren = true;
        }
      }
    };

    while (!end) {
      itemWithLongEnoughPath = null;

      window.json.items.forEach(buildChildren);
      i += 1;

      if (itemWithLongEnoughPath === null) {
        end = true;
      }
    }
    window.itemsAsTree = itemsAsTree;

    return {
      rootElement: {
        key: 'ExportViewer',
        type: ExportViewer
      },
      selectedItem: null,
      strings,
      treeConfig: {
        itemsAsTree,
        expanded: true,
        loadChildren(data) {
          const children = [];

          let node;

          let key;

          if (!data.node.path) {
            // EEV-2: Fallback to the dummy root item
            node = itemsAsTree[data.node.id] || itemsAsTree;

            for (key in node.childsAsTree) {
              if (Object.prototype.hasOwnProperty.call(node.childsAsTree, key)) {
                children.push(node.childsAsTree[key]);
              }
            }
          } else {
            for (key in data.node.childsAsTree) {
              if (Object.prototype.hasOwnProperty.call(data.node.childsAsTree, key)) {
                children.push(data.node.childsAsTree[key]);
              }
            }
          }

          data.resolve(children);
        }
      },
      searchListConfig: {items: []},
      activeTab: 0
    };
  },
  reactiveProvide: {
    name: 'appData',
    include: [
      'searchListConfig',
      'treeConfig',
      'selectedItem',
      'activeTab',
      // methods
      'onItemSelect',
      'saveFile',
      // computed
      'isFolder'
    ]
  },
  methods: {
    onItemSelect(selectedItem) {
      this.selectedItem = selectedItem.node || selectedItem;
    },
    saveFile() {
      const path = `${this.selectedItem.path.join('/') }/${this.selectedItem.id }.${this.selectedItem.ext}`;

      const link = document.createElement('a');

      link.setAttribute('href', path);
      link.setAttribute('download', `${this.selectedItem.name }.${this.selectedItem.ext}`);
      // Required for FF
      document.body.appendChild(link);

      link.click();
    }
  },
  watch: {
    isFolder(newVal) {
      if (newVal) {
        this.activeTab = 1;
      } else {
        this.activeTab = 0;
      }
    }
  },
  computed: {
    isFolder() {
      return this.selectedItem && !this.selectedItem.ext;
    }
  }
};
</script>

<style>
html {
  overflow: hidden;
  height: 100%;
}

body {
  height: 100%;
}

.selected {
  background-color: lightblue;
}

.itemcontainer {
  margin-left: 25px;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
}

.clickable {
  cursor: pointer;
}

.e-document-view-iframe {
  border: none;
  height: 100%;
  width: 100%;
}

.tree,
.list {
  overflow-y: auto !important;
}

.keyword-value {
  margin-left: 25px;
  min-height: 1.5em;
}

.right-container .e-view__content > div {
  height: 100%;
  overflow: auto;
}
.searchField {
  width: 100%;
}

.content-toggle-btns {
  margin-left: 1rem;
}
.level-icon {
  width: 16px;
  height: 16px;
  margin: 2px 6px 2px 0px;
  vertical-align: top;
}

.e-tn-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

/* the following is a fix for the e-header component and should be fix from their developers */
/* .e-header .e-header-title {
  flex: 2;
}
.e-header .e-header-content {
  display: flex;
  flex: 1;
} */
</style>
